import React, { useState, useContext, useEffect } from 'react';
import { useHistory } from 'react-router';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import request from '../../../services/Request';
import Swal from 'sweetalert2';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import { useTheme } from '@mui/material/styles';
import { Autocomplete } from '@mui/material';
import { TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { imageOnError } from '../../../services/method/methods';
import { CloudDownload, CloudDownloadOutlined } from '@mui/icons-material';
import { sortPOS } from '../../../services/method/methods';
import Preket from '../../orders/prekit/Preket';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { ExportToCsv } from 'export-to-csv';
import {
  FormControlLabel,
  RadioGroup,
  Grid,
  Radio,
  Checkbox,
  Button,
  TableRow,
  TableCell,
  TableContainer,
  TableBody,
  Paper,
  Table,
  TableHead,
  Box,
  Typography,
  Chip,
  alpha,
} from '@mui/material';
import InventoryIcon from '@mui/icons-material/Inventory';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import CategoryIcon from '@mui/icons-material/Category';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MagexMachineInventoryCheck(props) {
  const theme = useTheme();
  // const [reflesh, setReflesh] = useState(false);
  const id = props.match.params.id;
  const [loading, setLoading] = useState(false);
  const [mc, setMc] = useState([]);
  const [select, setSelect] = useState(null);

  useEffect(() => {
    // check id is md5 or not
    console.log('id', id?.length);
    if (id?.length !== 32) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid URL',
        text: 'Please check the URL and try again.',
      });
      return;
    } else {
      setLoading(true);
      request({
        method: 'post',
        url: '/magex/CheckInventory/',
        data: {
          id: id,
        },
      }).then((res) => {
        console.log('res', res.data);
        setMc(res.data?.machines);
        setLoading(false);
      });
    }
  }, []);

  const checkInventory = async (mc) => {};

  const columns = [
    {
      title: 'Image',
      field: 'image',
      width: '10%',
      render: (rowData) =>
        rowData.img != '' ? (
          <img
            src={`${rowData.img}`}
            style={{ maxWidth: 100, maxHeight: 50, borderRadius: 8 }}
            alt=""
            onError={imageOnError}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            No image
          </Typography>
        ),
    },
    {
      title: 'Product Name',
      field: 'name',
      editable: 'never',
      render: (rowData) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CategoryIcon sx={{ fontSize: 16, color: theme.palette.text.secondary }} />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            {rowData.name}
          </Typography>
        </Box>
      ),
    },
    {
      title: 'Product ID',
      field: 'id',
      editable: 'never',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
          {rowData.id}
        </Typography>
      ),
    },
    {
      title: 'Price',
      field: 'price',
      editable: 'never',
      render: (rowData) => (
        <Chip
          icon={<AttachMoneyIcon sx={{ fontSize: 16 }} />}
          label={rowData.price?.toFixed(2) || '0.00'}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.success.main, 0.12),
            color: theme.palette.success.dark,
            border: `1.5px solid ${alpha(theme.palette.success.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.success.dark,
            },
          }}
        />
      ),
    },
    {
      title: 'Stock',
      field: 'qt',
      editable: 'never',
      render: (rowData) => (
        <Chip
          icon={<InventoryIcon sx={{ fontSize: 16 }} />}
          label={rowData.qt || 0}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
            '& .MuiChip-icon': {
              color: theme.palette.primary.dark,
            },
          }}
        />
      ),
    },
  ];

  return (
    <ModernPageContainer>
      {loading && <LoadingIcon />}

      <ModernPageHeader
        title="Inventory Check"
        subtitle="Check machine inventory status"
        icon={InventoryIcon}
      />

      <Paper
        sx={{
          p: 3,
          mt: 3,
          mb: 3,
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          border: `1px solid ${theme.palette.divider}`,
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Autocomplete
          sx={{ width: 300 }}
          value={select}
          options={mc}
          onChange={(event, value) => {
            setSelect(value);
          }}
          getOptionLabel={(option) =>
            option?.name ? `${option?.id}(${option?.name})` : option?.id
          }
          renderInput={(params) => (
            <TextField {...params} label="Select a machine" variant="outlined" />
          )}
        />
      </Paper>

      <Box sx={{ mt: 3 }}>
        <ModernTable
          columns={columns}
          data={select ? select?.products : []}
          title="Machine Inventory Check"
          options={{
            search: true,
            paging: true,
            // filtering: true,
            exportButton: true,
            pageSize: 20,
            pageSizeOptions: [5, 10, 20, 50, 100],
            exportAllData: true,
            exportFileName: 'Machine Inventory Check',
            sorting: true,
            // headerStyle: {
            //   backgroundColor: '#3f51b5',
            //   color: '#FFF',
            // },
          }}
        />
      </Box>
    </ModernPageContainer>
  );
}
